import React from 'react';
import ButtonClose from '../buttons/ButtonClose';
import Card from '../cards/Card';

export type ToastType = 'success' | 'warning' | 'error' | 'info';

export interface ToastProps {
  id: string;
  message: string;
  header?: string;
  type?: ToastType;
  onClose: (id: string) => void;
  /** Optional CTA (e.g. a Button) rendered under the message. */
  action?: React.ReactNode;
}

const typeToClass = {
  success: 'toast-success',
  warning: 'toast-warning',
  error: 'toast-error',
  info: 'toast-info',
};

const Toast: React.FC<ToastProps> = ({ id, message, header, type = 'info', onClose, action }) => (
  <Card
    className={`toast ${typeToClass[type] || ''}`}
    header={
      <>
        {header && <b>{header}</b>}
        <ButtonClose
          className='toast-close'
          aria-label='Close'
          onClick={() => onClose(id)}
          label='×'
        />
      </>
    }
  >
    <p className='toast-message'>{message}</p>
    {action ? <div className='toast-action'>{action}</div> : null}
  </Card>
);

export default Toast;
